import { type SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    style={{ overflow: 'visible', ...props.style }}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.67}
      d="M17.5 8.333H2.5M13.333 1.667V5M6.667 1.667V5m7.5 14.166H5.833c-1.4 0-2.1 0-2.635-.273a2.5 2.5 0 0 1-1.091-1.092c-.274-.535-.274-1.235-.274-2.635V8.5c0-1.4 0-2.1.274-2.635a2.5 2.5 0 0 1 1.091-1.092c.535-.273 1.235-.273 2.635-.273h8.334c1.4 0 2.1 0 2.635.273a2.5 2.5 0 0 1 1.092 1.092c.273.535.273 1.235.273 2.635v6.667c0 1.4 0 2.1-.273 2.635a2.5 2.5 0 0 1-1.092 1.091c-.535.274-1.235.274-2.635.274Z"
    />
  </svg>
);

export { SvgComponent as CalendarIcon };

